<template>
    <v-app id="app">
        <app-navigation></app-navigation>

        <v-content transition="slide-x-transition">
            <router-view></router-view>
        </v-content><br /><br /><br />

        <app-fast-navigation></app-fast-navigation>
        <!-- <v-card dark class="menu-acesso-rapido" height="0px">
                <v-bottom-nav dark>
                    <v-btn to="/" dark>
                        <span>Inicio</span>
                        <v-icon>home</v-icon>
                    </v-btn>

                    <v-btn to="/comunicados-listagem" dark>
                        <span>Comunicados</span>
                        <v-icon>announcement</v-icon>
                    </v-btn>

                    <v-btn dark>
                        <span>Eventos</span>
                        <v-icon>event</v-icon>
                    </v-btn>

                    <v-btn to="/Perfil/?slug=4b6e4b46-7fe6-4116-a9a3-563e7ed87be3" dark>
                        <span>Meu perfil</span>
                        <v-icon>face</v-icon>
                    </v-btn>
                </v-bottom-nav>
            </v-card> -->
    </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';
import AppFastNavigation from '@/components/AppFastNavigation';
import '@/assets/css/global.css';

export default {
    name: 'App',
    components: {
        AppNavigation,
        AppFastNavigation
    }
};
</script>

<style>
.menu-acesso-rapido{
        left: 0;
        bottom: 116px;
        position: fixed;
        width: 100%
    }
</style>
